class CustomSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange();
    this.addEventListener("change", this.onChange);
    this.addEventListener("mousedown", this.onMouseDown);
    this.addEventListener("blur", this.onBlur);
  }
  onMouseDown() {
    this.setAttribute("data-open", "");
  }
  onBlur() {
    this.removeAttribute("data-open");
  }
  onChange() {
    this.value !== "" && this.value !== "---" || this.selectedIndex === -1 ? this.setAttribute("selected", "") : this.removeAttribute("selected");
    this.removeAttribute("data-open");
  }
}
customElements.define("custom-select", CustomSelect, { extends: "select" });
